<app-widget [widget-meta]="this.data"
  class="widget-agenda"
  alertCount=""
  hidehelp="true">
  <!-- This tile has been retired and is no longer used in production. It was not tested with the bootstrap upgrade 05/2023 -->
  @if (cal.fetchAgenda(agendaCalendar) | async; as agenda) {
    @if (!!agendaCalendar.agendaCanvas && agendaCalendar.agendaCanvas.length > 0) {
      <div class="card mb-3">
        <div class="card-body">
          <div class="card-title">Canvas Events and Assignments</div>
          <ng-container [ngTemplateOutlet]="agendaTemplate" [ngTemplateOutletContext]="{calendar:agendaCalendar.agendaCanvas, type:'canvas'}">
          </ng-container>
        </div>
      </div>
    }
    <div class="card mb-3">
      <div class="card-body">
        <div class="card-title">{{cal.isEmployeeCal ? "School Events" : "Program Events"}}</div>
        @if (cal.isEmployeeCal) {
          @if (agendaCalendar.agendaSchool && agendaCalendar.agendaSchool.length > 0) {
            <ng-container
              [ngTemplateOutlet]="agendaTemplate" [ngTemplateOutletContext]="{calendar:agendaCalendar.agendaSchool, type:'school'}">
            </ng-container>
          } @else {
            <div class="card-body">
              You have no events today.
            </div>
          }
        }
        @if (!cal.isEmployeeCal) {
          @if (!!agendaCalendar.agendaProgram && agendaCalendar.agendaProgram.length > 0) {
            <ng-container
              [ngTemplateOutlet]="agendaTemplate" [ngTemplateOutletContext]="{calendar:agendaCalendar.agendaProgram, type:'program'}">
            </ng-container>
          } @else {
            <div class="card-body">
              You have no events today.
            </div>
          }
        }
      </div>
    </div>
    <!--<div class="card mb-3">
    <div class="card-body">
      <div class="card-title">Personal Events</div>
      <ng-container *ngIf="agendaCalendar.agendaTeams && agendaCalendar.agendaTeams.length > 0; else noEvents"
        [ngTemplateOutlet]="agendaTemplate" [ngTemplateOutletContext]="{calendar:agendaCalendar.agendaTeams, type:'teams'}">
      </ng-container>
    </div>
  </div>-->
} @else {
  <div class="widget-loading text-center">
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
}



<ng-template #agendaTemplate let-calendar="calendar" let-type='type'>
  @for (item of calendar; track item; let i = $index) {
    <div class="">
      <div>
        <span class="dot {{type}}-dot">&nbsp;</span>
        @if (!!item.Link) {
          <a href="{{item.Link}}" target="_blank">{{item.Title}}</a>
        }
        @if (!!!item.Link) {
          {{item.Title}}
        }
        <ng-container> - </ng-container>
        @if (item.AllDay) {
          All day
        }
        @if (!item.AllDay) {
          {{item.StartTime | date:'h:mm aa'}}
        }
        @if (item.Location) {
          - {{item.Location}}
        }
      </div>
    </div>
  }
</ng-template>

</app-widget>
